export const WIZARD_ROUTES = {
  UPLOAD_PAGE: 'upload',
  REPLACE_PAGE: 'replace',
  REPAIR_PAGE: 'repair',
  NO_ACTION_PAGE: 'no-action',
  UNKNOWN_PAGE: 'unknown',
  START_PAGE: 'start',
  ERROR_PAGE: 'error'
};
